import { defaultTheme, Text } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { UsContractPositionDetailed } from 'modules/domain/usContracts/types'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { labelTarif } from 'modules/utils/numbers/formatTarif'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { SelectableWrapper } from 'views/components/Card/Wrapper'
import { DeliveryPeriodData } from 'views/components/DealCard/DeliveryPeriod'
import { KeyValue } from 'views/components/KeyValue/KeyValue'

const Content = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px 0;
`
const PriciesBlock = styled.div`
  width: 248px;
  display: flex;
  justify-content: space-between;
`

export const WrapperCard = styled(SelectableWrapper)`
  &:hover {
    background-color: ${defaultTheme.color.primary8a};
  }
  transition: all 0.3s ease;
  // hack to keep cad size when scroll is visible
  min-width: 298px;
`

type Props = {
  position: UsContractPositionDetailed
  onPositionClick: (position: UsContractPositionDetailed) => void
  isSelected: boolean
}

export const PositionCard: FC<Props> = memo(({ position, onPositionClick, isSelected }) => {
  const { t } = useTranslation('deal')
  return (
    <WrapperCard selected={isSelected} onClick={() => onPositionClick(position)}>
      <Content>
        <div>
          <Text typography="accentLarge">{position.contract.company.name}</Text>
          <Text typography="bodyLarge" color="secondary">
            {position.contract.market_zone?.name ?? DASH}
          </Text>
        </div>
        <Text typography="bodyLarge">
          {position.contract.product.title}, {formatQuantity(Number(position.quantity))}, {position.symbol}
        </Text>
        <PriciesBlock>
          <KeyValue label={labelTarif(t('basis'))} labelTypo="bodySmall" valueTypo="accentLarge">
            {formatNumber(position.basis) || DASH}
          </KeyValue>
          <KeyValue label={labelTarif(t('futures'))} labelTypo="bodySmall" valueTypo="accentLarge">
            {formatNumber(position.futures_price) || DASH}
          </KeyValue>
          <KeyValue label={labelTarif(t('cash'))} labelTypo="bodySmall" valueTypo="accentLarge">
            {formatNumber(position.price) || DASH}
          </KeyValue>
        </PriciesBlock>

        <div>
          <DeliveryPeriodData data={{ start_date: position.start_date, end_date: position.end_date }} />
        </div>
        <Text typography="bodyLarge">{position.contract.address?.short_address}</Text>
      </Content>
    </WrapperCard>
  )
})
